import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
    public static requiredFalse(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value === false) {
                return null;
            }

            return { requiredFalse: true };
        };
    }

    public static minArrayLength(min: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            }

            return value.length >= min ? null : { minArrayLength: true };
        };
    }

    public static setValidators(formGroup: AbstractControl, controlNames: string[], validators: ValidatorFn[]) {
        controlNames.forEach(name => {
            const control = formGroup.get(name);
            if (control) {
                control.setValidators(validators);
                control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
            }
        });
    }

    public static clearValidators(formGroup: AbstractControl, controlNames: string[]) {
        controlNames.forEach(name => {
            const control = formGroup.get(name);
            if (control) {
                control.clearValidators();
                control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
            }
        });
    }

    public static clearAllValidators(formGroup: AbstractControl) {
        formGroup.clearValidators();
        formGroup.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    }
}
